export enum DEVELOPER_FORM_FIELDS {
	FIRST_NAME = 'FirstName',
	LAST_NAME = 'LastName',
	EMAIL = 'Email',
	PHONE = 'Phone',
}

export enum DEVELOPER_FORM_FIELDS_NAMES {
	FIRST_NAME = 'NEW_APPLICATION.LABEL.FIRST_NAME',
	LAST_NAME = 'NEW_APPLICATION.LABEL.LAST_NAME',
	EMAIL = 'NEW_APPLICATION.LABEL.EMAIL',
	PHONE = 'NEW_APPLICATION.LABEL.PHONE',
}

export type DeveloperDetailsTypes = {
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: string,
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: string,
	[DEVELOPER_FORM_FIELDS.EMAIL]: string,
	[DEVELOPER_FORM_FIELDS.PHONE]: string
};

export type DeveloperDetailsReturnTypes = {
	developerFirstName: string,
	developerLastName: string,
	developerEmail: string,
	developerPhone: string
};

export const developerInitialValues: DeveloperDetailsTypes = {
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: '',
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: '',
	[DEVELOPER_FORM_FIELDS.EMAIL]: '',
	[DEVELOPER_FORM_FIELDS.PHONE]: '',
};

export const getFormattedDeveloperFormFields = (formikValues): DeveloperDetailsReturnTypes => ({
	developerFirstName: formikValues?.[DEVELOPER_FORM_FIELDS.FIRST_NAME],
	developerLastName: formikValues?.[DEVELOPER_FORM_FIELDS.LAST_NAME],
	developerEmail: formikValues?.[DEVELOPER_FORM_FIELDS.EMAIL],
	developerPhone: formikValues?.[DEVELOPER_FORM_FIELDS.PHONE]
});

export const convertDeveloperDetailsToInitial = (data): DeveloperDetailsTypes => ({
	[DEVELOPER_FORM_FIELDS.FIRST_NAME]: data?.developerContact?.developerFirstName ? data?.developerContact?.developerFirstName : '',
	[DEVELOPER_FORM_FIELDS.LAST_NAME]: data?.developerContact?.developerLastName ? data?.developerContact?.developerLastName : '',
	[DEVELOPER_FORM_FIELDS.EMAIL]: data?.developerContact?.developerEmail ? data?.developerContact?.developerEmail : '',
	[DEVELOPER_FORM_FIELDS.PHONE]: data?.developerContact?.developerPhone ? data?.developerContact?.developerPhone : '',
});
